import { transport } from 'config/transport';

export function callApiExportBaoCaoDuChiCongDoan(congDoanId, academicYear, submitToTW = false) {
    return transport.get(`/congdoan/${congDoanId}/nun/duchi/exportReport`, { params: { academicYear, submitToTW }, responseType: 'blob' });
}
